/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export const payoutReceiptText = language => ({
  en: { column: 'Receipts', loading: 'Loading receipts', error: 'Unavailable', empty: 'No issued receipts matched', pending: 'Awaiting settlement', unavailable: 'Stripe payout membership is unavailable', manual: 'Manually linked' },
  zh: { column: '收據', loading: '正在載入收據', error: '暫時無法載入', empty: '沒有已配對的收據', pending: '等待結算', unavailable: 'Stripe 尚未提供此結算的交易明細', manual: '手動連結' },
  cn: { column: '收据', loading: '正在载入收据', error: '暂时无法载入', empty: '没有已匹配的收据', pending: '等待结算', unavailable: 'Stripe 尚未提供此结算的交易明细', manual: '手动链接' }
}[language] || payoutReceiptText('en'));

export default function PayoutReceipts({ receiptState, language = 'en' }) {
  const text = payoutReceiptText(language);
  const state = receiptState || { loading: true };
  if (state.loading) return <span role="status" aria-label={text.loading}>…</span>;
  if (state.error) return <span title={state.error}>{text.error}</span>;
  const seen = new Set();
  const receipts = (state.payout?.components || []).filter(row => {
    if (row.active === false || !row.paymentId || !row.receiptNumber || seen.has(row.paymentId)) return false;
    seen.add(row.paymentId);
    return true;
  });
  const emptyText = state.payout?.membershipState === 'awaiting_settlement' ? text.pending :
    ['manual', 'unavailable'].includes(state.payout?.membershipState) ? text.unavailable : text.empty;
  return <span className="OrgPayout-receiptLinks">
    {receipts.length ? receipts.map((row, index) => <React.Fragment key={row.paymentId}>
      {index > 0 && ', '}
      <Link to={`/AccountOverview?paymentId=${row.paymentId}`} title={row.membership === 'manual' ? text.manual : undefined}>{row.receiptNumber}</Link>
    </React.Fragment>) : <span title={emptyText}>—</span>}
  </span>;
}
PayoutReceipts.propTypes = { receiptState: PropTypes.object, language: PropTypes.string };
